<template lang="pug">
  .landing-navigation.d-inline-flex.align-center
    figure(@click="goToHome" style="cursor: pointer;")
      img(src="../assets/landing/icon-home.png", alt="imagen del home")
    .d-flex.align-center(v-for="(item, index) in navig", :key="index" @click="goToPath(item.path, index)" :style="(index===navig.length-1)?'':'cursor: pointer;'")
        svg(width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M0.310022 0.710022C0.217319 0.802536 0.143771 0.912424 0.0935898 1.0334C0.0434083 1.15437 0.0175781 1.28405 0.0175781 1.41502C0.0175781 1.54599 0.0434083 1.67567 0.0935898 1.79665C0.143771 1.91762 0.217319 2.02751 0.310022 2.12002L4.19002 6.00002L0.310022 9.88002C0.123045 10.067 0.0180016 10.3206 0.0180016 10.585C0.0180016 10.8494 0.123045 11.103 0.310022 11.29C0.497 11.477 0.750596 11.582 1.01502 11.582C1.27945 11.582 1.53304 11.477 1.72002 11.29L6.31002 6.70002C6.40273 6.60751 6.47627 6.49762 6.52646 6.37665C6.57664 6.25567 6.60247 6.12599 6.60247 5.99502C6.60247 5.86405 6.57664 5.73437 6.52646 5.6134C6.47627 5.49242 6.40273 5.38253 6.31002 5.29002L1.72002 0.700022C1.34002 0.320022 0.700022 0.320022 0.310022 0.710022Z" fill="#0855C4")
        p(:class="{'active-nav': item.active}") {{item.name}}
</template>
<script>
export default{
  props: ['navig'],
  methods: {
    goToHome () {
      this.$router.push('/').catch(() => {})
    },
    goToPath (path, index) {
      try {
        if (index === 0 && this.navig.length >= 2) {
          this.$router.go(0)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LandingNavig.vue